/**
 * 通用js方法封装处理
 * Copyright (c) 2019 gft
 */

const baseURL = process.env.VUE_APP_BASE_API

// 日期格式化
export function parseTime(time, pattern) {
	if (arguments.length === 0 || !time) {
		return null
	}
	const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
	let date
	if (typeof time === 'object') {
		date = time
	} else {
		if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
			time = parseInt(time)
		} else if (typeof time === 'string') {
			time = time.replace(new RegExp(/-/gm), '/');
		}
		if ((typeof time === 'number') && (time.toString().length === 10)) {
			time = time * 1000
		}
		date = new Date(time)
	}
	const formatObj = {
		y: date.getFullYear(),
		m: date.getMonth() + 1,
		d: date.getDate(),
		h: date.getHours(),
		i: date.getMinutes(),
		s: date.getSeconds(),
		a: date.getDay()
	}
	const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
		let value = formatObj[key]
		// Note: getDay() returns 0 on Sunday
		if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
		if (result.length > 0 && value < 10) {
			value = '0' + value
		}
		return value || 0
	})
	return time_str
}

// 表单重置
export function resetForm(refName) {
	if (this.$refs[refName]) {
		this.$refs[refName].resetFields();
	}
}

// 添加日期范围
export function addDateRange(params, dateRange) {
	var search = params;
	search.beginTime = "";
	search.endTime = "";
	if (null != dateRange && '' != dateRange) {
		search.beginTime = this.dateRange[0];
		search.endTime = this.dateRange[1];
	}
	return search;
}

// 回显数据字典
export function selectDictLabel(datas, value) {
	var actions = [];
	if (!datas) {
		return actions.join('');
	}
	Object.keys(datas).some((key) => {
		if (datas[key].dictValue == ('' + value)) {
			actions.push(datas[key].dictLabel);
			return true;
		}
	})
	return actions.join('');
}

// 回显数据字典（字符串数组）
export function selectDictLabels(datas, value, separator) {
	var actions = [];
	if (!datas || !value) {
		return actions.join('');
	}
	var currentSeparator = undefined === separator ? "," : separator;
	var temp = value.split(currentSeparator);
	Object.keys(value.split(currentSeparator)).some((val) => {
        Object.keys(datas).some((key) => {
            if (datas[key].dictValue == ('' + temp[val])) {
				actions.push(datas[key].dictLabel + currentSeparator);
			}
		})
	})
	return actions.join('').substring(0, actions.join('').length - 1);
}

// 通用下载方法
export function download(fileName) {
	window.location.href = baseURL + "/common/download?fileName=" + encodeURI(fileName) + "&delete=" + true;
}

// 字符串格式化(%s )
export function sprintf(str) {
	var args = arguments, flag = true, i = 1;
	str = str.replace(/%s/g, function () {
		var arg = args[i++];
		if (typeof arg === 'undefined') {
			flag = false;
			return '';
		}
		return arg;
	});
	return flag ? str : '';
}

// 转换字符串，undefined,null等转化为""
export function praseStrEmpty(str) {
	if (!str || str == "undefined" || str == "null") {
		return "";
	}
	return str;
}

// 转换字符串，undefined,null等转化为""
export function isStrEmpty(str) {
  if (!str || str == "undefined" || str == "null") {
    return true;
  }
  return false;
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 * @param {*} rootId 根Id 默认 0
 */
export function handleTree(data, id, parentId, children, rootId) {
	id = id || 'id'
	parentId = parentId || 'parentId'
	children = children || 'children'
	rootId = rootId || Math.min.apply(Math, data.map(item => { return item[parentId] })) || 0
	//对源数据深度克隆
	const cloneData = JSON.parse(JSON.stringify(data))
	//循环所有项
	const treeData = cloneData.filter(father => {
		let branchArr = cloneData.filter(child => {
			//返回每一项的子级数组
			return father[id] === child[parentId]
		});
		branchArr.length > 0 ? father.children = branchArr : '';
		//返回第一层
		return father[parentId] === rootId;
	});
	return treeData != '' ? treeData : data;
}

  /**
   * 参数处理
   * @param {*} params  参数
   */
export function tansParams(params) {
	let result = ''
	Object.keys(params).forEach((key) => {
		if (!Object.is(params[key], undefined) && !Object.is(params[key], null)) {
       result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
		}
	})
	return result
}
/*****add by robert***/
var chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
function generateMixed(n) {
  var res = "";
  for (var i = 0; i < n; i++) {
    var id = Math.ceil(Math.random() * 35);
    res += chars[id];
  }
  return res;
}
//使用路由跳转
export function routerLink(){
  let params = {};
  let path = arguments[0] ? arguments[0] : null;
  params['type'] = arguments[1] ? arguments[1] : null;
  params['id'] = arguments[2] ? arguments[2] : 0;
  // params['noce_str'] = generateMixed(7);
  let obj = arguments[3] ? arguments[3] : null;
  if (obj != null) {
    if (typeof obj == "object") {
      for (let key in obj) {
        params[key] = obj[key];
      }
    } else {
      throw new Exception("路由链接函数第四个参数只支持object类型");
    }
  }

  this.$router.push({
      path: path,
      query: params
  })
}

//列表日期格式化
export function listDateFormatter(cellValue, pattern){
  return parseTime(new Date(cellValue), pattern)
}

//翻译列表字典表信息
export function listDatasFormatter(row,column,dicData){
  let results = row[column.property]; // 默认原真实值
  if(dicData && dicData.length>0){
      for(let i=0;i<dicData.length;i++){
          let item = dicData[i];
          if(row[column.property] === item.dicKey){
              results = item.dicValue;
              break;
          }
      }
  }
  return results;
}
/**
 * 根据用户ID递归查找IM中对应的ITEM
 * @param {*} userId 
 * @param {*} items 
 * @returns 
 */
function _getUserById(userId,items){
	var result = null;
    for(let idx in items){
      if(items[idx].username && items[idx].id == userId){
        result = items[idx];
        break;
      }
      let children = items[idx].list;
      if(children){
        result = _getUserById(userId,children);
        if(result){
          break;
        }
      }
    }
    return result;
}

/**
 * 根据用户ID打开指定用户的IM窗口
 * @param {*} userId 
 */
export function showChatFormByUserId(userId){
	let layim = layui.layim;
	var userItem = _getUserById(userId,layim.cache().friend);
    userItem && layim.chat({
      type:'friend',
      name:userItem.username,
      ...userItem
    });
}

/**
 * 左右拖动
 */
export function dragControllerDiv() {
	var resize = document.getElementsByClassName('dragDropResize');
	var left = document.getElementsByClassName('dragDropLeft');
	var mid = document.getElementsByClassName('dragDropMid');
	var box = document.getElementsByClassName('dragDropBox');
	for (let i = 0; i < resize.length; i++) {
		// 鼠标按下事件
		resize[i].onmousedown = function (e) {
			//颜色改变提醒
			resize[i].style.background = '#818181';
			var startX = e.clientX;
			resize[i].left = resize[i].offsetLeft;
			// 鼠标拖动事件
			document.onmousemove = function (e) {
				var endX = e.clientX;
				var moveLen = resize[i].left + (endX - startX); // （endx-startx）=移动的距离。resize[i].left+移动的距离=左边区域最后的宽度
				var maxT = box[i].clientWidth - resize[i].offsetWidth; // 容器宽度 - 左边区域的宽度 = 右边区域的宽度

				if (moveLen < 32) moveLen = 32; // 左边区域的最小宽度为32px
				if (moveLen > maxT - 150) moveLen = maxT - 150; //右边区域最小宽度为150px

				resize[i].style.left = moveLen; // 设置左侧区域的宽度

				for (let j = 0; j < left.length; j++) {
					left[j].style.width = moveLen + 'px';
					mid[j].style.width = (box[i].clientWidth - moveLen - 10) + 'px';
				}
			};
			// 鼠标松开事件
			document.onmouseup = function (evt) {
				//颜色恢复
				resize[i].style.background = '#d6d6d6';
				document.onmousemove = null;
				document.onmouseup = null;
				resize[i].releaseCapture && resize[i].releaseCapture(); //当你不在需要继续获得鼠标消息就要应该调用ReleaseCapture()释放掉
			};
			resize[i].setCapture && resize[i].setCapture(); //该函数在属于当前线程的指定窗口里设置鼠标捕获
			return false;
		};
	}
}
